import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient) { }
  async getConfig() {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = { 'Content-Type': 'application/json' };
    const body = {
      "client": `${environment.companyName}`,
      "company": `${environment.companyId}`
    }

    return await this.http.post(`${environment.apiServer}/config`, body, { headers }).toPromise();
  }

  async getConfigs() {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = { 'Content-Type': 'application/json' };
    const body = {
      "client": `configs`,
      // "company": `configs` 
    }

    return await this.http.post(`${environment.apiServer}/config`, body, { headers }).toPromise();
  }

  async getToken(site: string, comp: string) {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = { 'Content-Type': 'application/json' };
    const body = {
      "client": site,
      "company": comp
    }

    return await this.http.post(`${environment.apiServer}/token`, body, { headers }).toPromise();
  }
}
